import React from 'react';
import { generateId } from '../../utility/functions';
import Table from '../../table/Table';
import Button from '../../forms/Button';
import PageBreak from '../../layout/PageBreak';
import FormSetting from '../../layout/FormSetting';
import Checkbox from '../../forms/Checkbox';
import Input from '../../forms/Input';
import Select from '../../forms/Select';
import TextArea from '../../forms/TextArea';
import GetState, { loadingSelectState } from '../../GetState';
import { QuestRoute } from '../../api/QuestRoutes';
import Heading from '../../forms/Heading';
import HamQuest from '../../api/HamQuestGiver';
import Preput from '../../forms/Preput';
import Radio from '../../forms/Radio';
import LocationSelectors from '../../forms/formComponents/LocationSelectors';
import TerminalIDsSelector from '../../forms/formComponents/TerminalIDsSelector';
import Form from '../../forms/Form';
import ColorInput from '../../forms/formComponents/ColorInput';
import ImageIndex from '../../forms/formComponents/ImageIndex';
import ManagementRow from '../../table/ManagementRow';
import ModalFactory from '../../Modal';
import UpgradeAndAutoSelect from '../../forms/formComponents/UpgradeAndAutoSelect';
import RequireFeature, { Features } from '../../RequireFeature';

const LoyaltyPoints = ({ ...props }) => {

    const [awards, refreshBundles] = GetState(QuestRoute.points.awards, { loading: loadingSelectState });

    const deleteRefAward = (ref) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to delete ${ref.name}?`,
                type: 'warning',
            },
            promise: {
                title: 'Deleting Referral',
                body: `Deleting ${ref.name}`,
                callback: () => HamQuest.delete(QuestRoute.points.edit(ref.awardId))
            },
            confirmed: {
                title: 'Success',
                body: `${ref.name} successfully deleted.`,
                type: 'success'
            },
            finally: () => refreshBundles()
        })
    }

    const editRefAward = (ref) => {
        // console.log(ref)
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Edit ${ref.name}`,
            body: (
                <Form
                    name='loyaltyPointSettings'
                    inputs={{ ...ref }}
                    onSubmit={e => HamQuest.put(QuestRoute.points.edit(e.awardId), { ...e })
                        .then(() => {
                            refreshBundles();
                            ModalFactory.close(id);
                        })
                    }
                    text='Update'
                >
                    {({ values }) =>
                        <>
                            <Input
                                label='Name'
                                name='name'
                                required
                            />
                            <Preput
                                label='Description'
                                name='description'
                            />
                            <Input
                                label='SKU'
                                name='sku'
                            />
                            <Radio
                                label='Item'
                                name='kioskItemId'
                                getOptions={QuestRoute.kiosks.wash}
                                buildOptions={e => {
                                    e.label = e.name
                                    e.value = e.id
                                }}
                                required
                            />
                            <Input
                                label='Expires in (Days)'
                                name='expires'
                                type='number'
                                required
                            />

                            <UpgradeAndAutoSelect isAward={true} />
                            <LocationSelectors />
                            <TerminalIDsSelector />
                        </>
                    }
                </Form>
            )
        })
    }

    const addNewRefAward = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Add a new Loyalty`,
            body: (
                <Form
                    name='loyaltyPointSettings'
                    inputs={{
                        name: '',
                        description: '',
                        sku: '',
                        kioskItemId: '',
                        expires: '',
                        allowUpgrades: '',
                        autoSelectItem: '',
                        locations: [],
                        terminalIds: [],
                    }}
                    onSubmit={e => HamQuest.post(QuestRoute.points.awards, { ...e })
                        .then(() => {
                            refreshBundles();
                            ModalFactory.close(id);
                        })
                    }
                    text='Add'
                >
                    {({ values }) =>

                        <>
                            <Input
                                label='Name'
                                name='name'
                                required
                            />
                            <Preput
                                label='Description'
                                name='description'
                            />
                            <Input
                                label='SKU'
                                name='sku'
                            />
                            <Radio
                                label='Item'
                                name='kioskItemId'
                                getOptions={QuestRoute.kiosks.wash}
                                buildOptions={e => {
                                    e.label = e.name
                                    e.value = e.id
                                }}
                                required
                            />
                            <Input
                                label='Expires in (Days)'
                                name='expires'
                                type='number'
                                required
                            />

                            <UpgradeAndAutoSelect isAward={true} />

                            <LocationSelectors />

                            <TerminalIDsSelector />
                        </>
                    }
                </Form>
            )
        })
    }



    return (
        <PageBreak>
            <Table
                config={{
                    label: 'Awards',
                    controls: [<Button onClick={addNewRefAward}>Add New Loyalty Point Award</Button>],
                    data: awards,
                    headers: [
                        {
                            label: 'Name',
                            propKey: 'name',
                        }, {
                            label: 'Description',
                            propKey: 'description ',
                        }, {
                            label: 'SKU',
                            propKey: 'sku',
                        }, {
                            label: 'Item',
                            propKey: 'kioskItemName',
                            options: true,
                        },
                    ],
                    renderFormat: (e) => (
                        <ManagementRow
                            key={generateId()}
                            controls={[
                                <Button key={generateId()} onClick={() => editRefAward(e)}>Edit</Button>,
                                < Button key={generateId()} onClick={() => deleteRefAward(e)}>Delete</Button>
                            ]}
                        >
                            <td>{e.name}</td>
                            <td>{e.description}</td>
                            <td>{e.sku}</td>
                            <td>{e.kioskItemName}</td>
                        </ManagementRow >
                    )
                }}
            />

            < FormSetting
                label='Settings'
                getInputs={QuestRoute.points.settings}
                onSubmit={e => HamQuest.put(QuestRoute.points.settings, { ...e })}
                editable
            >
                <PageBreak>
                    <>
                        <Checkbox
                            label='App Wash Purchases'
                            name='allowWashPoints'
                        />
                        <Checkbox
                            label='App Bundle Purchases'
                            name='allowBundlePoints'
                        />
                        <Checkbox
                            label='AirPAY Purchases'
                            name='allowAirPayPoints'
                        />
                        </>
                        <RequireFeature requiredFeatures={Features.AppCredit}>
                            <Heading>App Credit Points</Heading>
                            <Checkbox
                                label='Buying App Credit'
                                name='allowAppCreditPoints'
                            />
                            <Checkbox
                                label='Redeeming App Credit'
                                name='allowAppCreditRedemptionPoints'
                            />
                        </RequireFeature>
                        <>
                        <Input
                            label='Point Goal'
                            name='pointGoal'
                            type='number'
                            min={0}
                            required
                        />
                        <Input
                            label='Widget Title'
                            name='pointsWidgetTitle'
                            required
                        />
                        <Select
                            label='Award'
                            name='pointAwardId'
                            options={awards.map(e => ({
                                value: e.awardId,
                                label: e.name
                            }))}
                            required
                        />

                        <ColorInput
                            name='logoRGB'
                        />
                        <ImageIndex
                            colorName='logoRGB'
                        />

                        <Preput
                            label='Widget Description'
                            name='pointsWidgetDescription'
                            required
                        />
                    </>

                    <>
                        <Heading>Notifications</Heading>
                        <Input
                            label='Notification Subject'
                            name='notificationSubject'
                            required
                        />
                        <Preput
                            label='Notification Body'
                            name='notificationBody'
                            tags={['FirstName', 'LastName', 'FullName', 'KioskItemName']}
                            required
                        />
                    </>

                    <>
                        <Heading>Email</Heading>
                        <Checkbox
                            label='Email Enabled'
                            name='emailsEnabled'
                        />
                        <Input
                            label='Email Subject'
                            name='emailSubject'
                            required
                        />
                        <TextArea
                            name='emailBody'
                            tags={['FirstName', 'LastName', 'FullName', 'KioskItemName']}
                            required
                        />
                    </>
                </PageBreak>

            </FormSetting >
        </PageBreak >

    );
}

export default LoyaltyPoints;